import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.375 18.5H3.62501C3.09376 18.5 2.71429 18.1205 2.71429 17.5893C2.71429 17.096 3.09376 16.6786 3.62501 16.6786H16.375C16.8683 16.6786 17.2857 17.096 17.2857 17.5893C17.2857 18.1205 16.8683 18.5 16.375 18.5ZM9.31697 13.3772L4.45983 8.21652C4.11831 7.83705 4.15626 7.26786 4.49778 6.92634C4.87724 6.58482 5.44644 6.58482 5.78796 6.96429L9.08929 10.4554V2.41071C9.08929 1.91741 9.46876 1.5 10 1.5C10.4933 1.5 10.9107 1.91741 10.9107 2.41071V10.4554L14.1741 6.96429C14.5156 6.58482 15.0848 6.58482 15.4643 6.92634C15.8438 7.26786 15.8438 7.83705 15.5022 8.21652L10.6451 13.3772C10.4554 13.567 10.2277 13.6429 10 13.6429C9.73438 13.6429 9.50671 13.567 9.31697 13.3772Z",
		fill: "#0D2976"
	})
});
export default SvgExport;
